import { useLang } from "@/i18n";

export default function Marquee() {
  const { t } = useLang();
  const items = t("marquee.items").split("|");
  const row = [...items, ...items];
  return (
    <div className="border-y border-[#E2E8F0] bg-white py-4 overflow-hidden" data-testid="editorial-marquee">
      <div className="marquee-track flex whitespace-nowrap w-max">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-8 pr-8 text-sm font-bold uppercase tracking-[0.22em] text-[#94A3B8]">
            {item}
            <span className="w-1.5 h-1.5 rounded-full bg-[#00AEEF] inline-block" />
          </span>
        ))}
      </div>
    </div>
  );
}
